import { render, staticRenderFns } from "./CopyrightAttachments.vue?vue&type=template&id=73177ae4&scoped=true&"
import script from "./CopyrightAttachments.vue?vue&type=script&lang=js&"
export * from "./CopyrightAttachments.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAttachments.vue?vue&type=style&index=0&id=73177ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73177ae4",
  null
  
)

export default component.exports